<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-long-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div v-loading="isLoading">
      <form-editor
        :data="data"
        :model="formModel"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        isCancel
        isCreate
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import { ServiceRFQ2s } from '@/services/RFQ2s'
import { getCurrentEmployee } from '@/utils/shared'

export default {
  name: 'ModalPoWoBasedCustomerOpenPo',
  mixins: [FormWrapper],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQ2Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object },
    rfqid: { required: true }
  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      const model = this.copyObjectProps(ServiceRFQ2s.getModel(), {
        rfqid: this.rfqid,
        employeeID: getCurrentEmployee().id,
        entryDate: this.$moment(new Date()).add(-3, 'M').add(-1, 'day').toDate()
      })
      return model
    },
    handleDialogClose () {
      this.setCommand('cancel')
    }
  }
}
</script>
